import script from "./ChatParticipant.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatParticipant.vue?vue&type=script&setup=true&lang=js"

import "./ChatParticipant.vue?vue&type=style&index=0&id=c771a372&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c771a372"]])

export default __exports__